import ctt from '@/utils/const/deviceType';

export const mods = [
  {
    icon: 'chemical-weapon',
    title: '化学战剂',
    mod: 'cwaMod'
  },
  {
    icon: 'dupin',
    title: '有毒有害气体',
    mod: 'tvocMod'
  },
  {
    icon: 'leaf',
    title: '空气质量检测',
    mod: 'smokeMod'
  },
  {
    icon: 'iconmonstr-danger--icon',
    title: '生物因子',
    mod: 'bioMod'
  }
];

export const modMap = mods.reduce((map, e) => {
  map[e.mod] = e;
  return map;
}, {});

const deviceTypeMods = {
  [ctt.FCBR_100M]: ['cwaMod', 'tvocMod', 'smokeMod'],
  [ctt.B02_V2]: ['bioMod']
};

export const getModOptions = deviceType => {
  const mods = deviceTypeMods[deviceType];
  if (!mods) return [];
  return mods.map(mod => modMap[mod]);
};
